import {
  passwordChangeRoutePath,
  passwordResetRoutePath,
  registerRoutePath,
  signInRoutePath,
} from 'config/routePaths'
import { useApiMutation } from 'utils/queryClient'

export const useEmailPasswordAuth = (isRegister, options = {}) =>
  useApiMutation(isRegister ? registerRoutePath : signInRoutePath, 'post', options)

export const useSignIn = (options = {}) =>
  useApiMutation(signInRoutePath, 'post', options)

export const usePasswordReset = (options = {}) =>
  useApiMutation(passwordResetRoutePath, 'post', options)

export const usePasswordChange = (options = {}) =>
  useApiMutation(passwordChangeRoutePath, 'post', options)
